import React, { Component } from 'react'
import PropTypes from 'prop-types';
import NotFound from './NotFound'
import autoBind from "react-autobind";

class NotFoundContainer extends Component {

  constructor(props) {
    super(props)
    autoBind(this);
    const message = props.location.state ? props.location.state.message : null

    this.state = {
      message: message
    }
  }

  render() {

    return (
      <div>
        <NotFound  />
      </div>
    )
  }
}

NotFoundContainer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    state: PropTypes.object.isRequired,
  })
};

export default NotFoundContainer



// WEBPACK FOOTER //
// ./src/components/notFound/NotFoundContainer.js